'use client';

import React from 'react';
import { Tooltip } from '@heroui/react';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareCampaign } from '../types';
import { InfoCircle } from '../../../../components/icons';
import { SYSTEM_FEE_PERCENT } from '../../offers/constants';
import { ResponsiveTooltip } from '../../../../components';

interface IncomeCellProps {
  campaign: RevshareCampaign;
}

const IncomeCell: React.FC<IncomeCellProps> = ({ campaign }) => {
  const { t } = useTranslations();

  // Calculate partner income (clean income)
  // Partner income = total revenue * (commission / 100)
  const totalRevenue = Number(campaign.transactions_statistic?.total || 0);
  const commission = Math.max((campaign.offer?.commission || 0) - SYSTEM_FEE_PERCENT, 0);
  const partnerIncome = totalRevenue * (commission / 100);

  // Percentage is just the commission percentage
  const incomePercent = commission.toFixed(0);

  return (
    <div className="flex items-center gap-2 py-2">
      <span className="text-sm font-semibold text-auth-ink">${partnerIncome.toFixed(2)}</span>
      <span className="text-sm text-auth-muted">({incomePercent}%)</span>
      <ResponsiveTooltip
        content={
          t('partner.partnerCampaigns.statistics.incomeTooltip') ||
          'Чистий дохід маркетолога та його % від тотальної суми'
        }
        placement="top"
      >
        <span className="cursor-pointer">
          <InfoCircle className="w-4 h-4 text-auth-muted" />
        </span>
      </ResponsiveTooltip>
    </div>
  );
};

export default IncomeCell;
